// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3-_tZ","row":"ProcedureTreatmentSummary_row__32nrn"};